import { lazyLoad } from "utils/loadable";

const AnnouncementsPage = lazyLoad(
  () => import("./index"),
  (module) => module.AnnouncementsPage,
  {
    fallback: (
      <div>
        <p>Loading....</p>
      </div>
    ),
  }
);

export default AnnouncementsPage;
